'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _every2 = require('./_internal/_every');

var _every3 = _interopRequireDefault(_every2);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _reverse = require('./reverse');

var _reverse2 = _interopRequireDefault(_reverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var everyBy = (0, _reverse2.default)(_every3.default, _INT_TWO2.default); /**
                                                                           * Determine if all values in array satisfy function
                                                                           *
                                                                           * @module everyBy
                                                                           * @func
                                                                           * @since 1.17.0
                                                                           * @param {function} fn
                                                                           * @param {Array} arr
                                                                           * @return {function|boolean}
                                                                           * @example
                                                                           *
                                                                           *     const isTrue = val => val === true;
                                                                           *     everyBy(isTrue, [true, true]) //=> true
                                                                           *     everyBy(isTrue)([true, false]) //=> false
                                                                           */

exports.default = everyBy;